
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import PropTypes from 'prop-types'
import { useQuery } from 'react-query';
import useUserActions from 'hook/useUserActions';
import { useState } from 'react';
import { format } from "date-fns";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend
);

export const options = {
    responsive: true,
    plugins: {
        legend: {
            display: false
        },
    },
};

const LineChart = ({ data }) => {
    return (
        <Line options={options} data={data || { labels: [], datasets: [] }} />
    );
}

export default LineChart;
LineChart.propTypes = {
    data: PropTypes.object,
}
